function step(id, title, next) {
  return {
    id,
    title,
    description: '',
    type: 'step',
    required: true,
    placeholder: '',
    config: {
      send_sms_after_answer: false,
      admin_approval: false,
      send_sms_after_admin_approval: false,
      next: next || {default: '', rules: []}
    }
  }
}

function select(id, title, variable, options) {
  return {
    id,
    title,
    description: '',
    type: 'selectbox',
    required: true,
    placeholder: '',
    variable,
    options: options.map((option, index) => ({
      id: String(index + 1),
      label: option.label,
      value: index === 0 ? 1 : 0,
      price: option.price
    }))
  }
}

function radio(id, title, variable, options) {
  return {
    id,
    title,
    description: '',
    type: 'radiobox',
    required: true,
    placeholder: '',
    slug: variable,
    variable,
    options: options.map((option, index) => ({
      id: String(index + 1),
      label: option.label,
      value: index === 0 ? 1 : 0,
      image: '',
      price: typeof option.price === 'undefined' ? '' : option.price
    }))
  }
}

function text(id, title, variable) {
  return {
    id,
    title,
    description: '',
    type: 'text',
    required: true,
    placeholder: '',
    variable,
    config: {pattern: ''}
  }
}

function eqRule(id, next, questionId, stepId, variable, value) {
  return {
    id,
    next,
    when: {
      all: [{
        question_id: questionId,
        step_id: stepId,
        variable,
        op: 'eq',
        value
      }]
    }
  }
}

function priceRule(id, title, formula, questionId, stepId, variable, value) {
  return {
    id,
    title,
    formula,
    when: {
      all: [{
        question_id: questionId,
        step_id: stepId,
        variable,
        op: 'eq',
        value
      }]
    }
  }
}

const VAT = '1.1'

export const thirdPartyInsurance1405Form = {
  total_score: null,
  answer_without_login: true,
  send_sms_after_answer_for_admin: false,
  send_email_after_answer_for_admin: false,
  price: {
    enabled: true,
    value_source: 'option_price',
    default_formula: `{{q:4}} * {{q:5}} * ${VAT}`,
    rules: [
      priceRule('price_passenger', 'سواری', `{{q:4}} * {{q:5}} * ${VAT}`, 2, 1, 'vehicle_category', '1'),
      priceRule('price_cargo', 'بارکش', `{{q:7}} * {{q:8}} * ${VAT}`, 2, 1, 'vehicle_category', '2'),
      priceRule('price_public', 'عمومی', `{{q:10}} * {{q:11}} * ${VAT}`, 2, 1, 'vehicle_category', '3'),
      priceRule('price_moto', 'موتورسیکلت', `{{q:13}} * ${VAT}`, 2, 1, 'vehicle_category', '4'),
      priceRule('price_other', 'سایر', `{{q:15}} * ${VAT}`, 2, 1, 'vehicle_category', '5'),
      priceRule('price_rail', 'ریلی', `{{q:17}} * ${VAT}`, 2, 1, 'vehicle_category', '6')
    ]
  },
  form: [
    step(1, 'نوع وسیله نقلیه', {
      default: '',
      rules: [
        eqRule('rule_to_passenger', 3, 2, 1, 'vehicle_category', '1'),
        eqRule('rule_to_cargo', 6, 2, 1, 'vehicle_category', '2'),
        eqRule('rule_to_public', 9, 2, 1, 'vehicle_category', '3'),
        eqRule('rule_to_moto', 12, 2, 1, 'vehicle_category', '4'),
        eqRule('rule_to_other', 14, 2, 1, 'vehicle_category', '5'),
        eqRule('rule_to_rail', 16, 2, 1, 'vehicle_category', '6')
      ]
    }),
    select(2, 'نوع وسیله نقلیه', 'vehicle_category', [
      {label: 'خودرو سواری', price: ''},
      {label: 'خودرو بارکش', price: ''},
      {label: 'خودرو عمومی / اتوکار', price: ''},
      {label: 'موتورسیکلت', price: ''},
      {label: 'سایر خودروها', price: ''},
      {label: 'وسیله نقلیه ریلی', price: ''}
    ]),

    step(3, 'سواری', {default: 18, rules: []}),
    select(4, 'کلاس سیلندر سواری', 'passenger_class', [
      {label: 'کمتر از ۴ سیلندر', price: 75522000},
      {label: 'پیکان، پراید و سپند', price: 89440000},
      {label: 'سایر ۴ سیلندر', price: 105132000},
      {label: 'بیش از ۴ سیلندر', price: 117665000}
    ]),
    select(5, 'کاربری سواری', 'passenger_usage', [
      {label: 'شخصی / بدون کاربری خاص', price: 1},
      {label: 'تاکسی، آژانس، کرایه و مسافربری شهری', price: 1.1},
      {label: 'مسافربری بین شهری', price: 1.2}
    ]),

    step(6, 'بارکش', {default: 18, rules: []}),
    select(7, 'ظرفیت بارکش', 'cargo_class', [
      {label: 'تا ۱ تن', price: 92533000},
      {label: 'بیش از ۱ تا ۳ تن', price: 111415000},
      {label: 'بیش از ۳ تا ۵ تن', price: 141024000},
      {label: 'بیش از ۵ تا ۱۰ تن', price: 180686000},
      {label: 'بیش از ۱۰ تا ۲۰ تن', price: 210263000},
      {label: 'بیش از ۲۰ تن', price: 222829000}
    ]),
    select(8, 'نوع محموله', 'cargo_hazard', [
      {label: 'بار عادی', price: 1},
      {label: 'سوخت مایع و گاز', price: 1.25},
      {label: 'مواد منفجره', price: 1.5}
    ]),

    step(9, 'عمومی / اتوکار', {default: 18, rules: []}),
    select(10, 'ظرفیت خودرو عمومی', 'public_class', [
      {label: 'استیشن ۷ نفره با راننده', price: 216578000},
      {label: 'استیشن ۹ نفره با راننده', price: 222829000},
      {label: 'ون ۱۰ نفره با راننده', price: 225311000},
      {label: 'مینی‌بوس ۱۶ نفره با راننده', price: 277023000},
      {label: 'مینی‌بوس ۲۱ نفره با راننده', price: 287752000},
      {label: 'اتوبوس ۲۷ نفره با راننده و کمک', price: 424298000},
      {label: 'اتوبوس ۴۰ نفره با راننده و کمک', price: 533845000},
      {label: 'اتوبوس ۴۴ نفره با راننده و کمک', price: 566547000}
    ]),
    select(11, 'حمل‌ونقل عمومی شهری', 'public_urban', [
      {label: 'عادی / غیرشهری', price: 1},
      {label: 'حمل‌ونقل عمومی شهری با ظرفیت بیش از ۶ نفر (۵۰٪ تخفیف)', price: 0.5}
    ]),

    step(12, 'موتورسیکلت', {default: 18, rules: []}),
    select(13, 'نوع موتورسیکلت', 'moto_class', [
      {label: 'گازی', price: 18750000},
      {label: 'دنده‌ای یک سیلندر', price: 22907000},
      {label: 'دو سیلندر و بیشتر', price: 25162000},
      {label: 'دنده‌ای سه چرخ یا سایدکار', price: 27063000}
    ]),

    step(14, 'سایر خودروها', {default: 18, rules: []}),
    select(15, 'نوع سایر خودروها', 'other_class', [
      {label: 'کشاورزی', price: 31306000},
      {label: 'راهسازی و ساختمانی', price: 55384000},
      {label: 'حمل زباله و جاروب خیابان', price: 90019000}
    ]),

    step(16, 'ریلی', {default: 18, rules: []}),
    select(17, 'نوع وسیله ریلی', 'rail_class', [
      {label: 'لکوموتیو یا سالن مسافری بین شهری', price: 317041000},
      {label: 'لکوموتیو یا سالن مسافری شهری / مترو', price: 36988000},
      {label: 'واگن باری بین شهری', price: 79259000}
    ]),

    step(18, 'وضعیت بیمه‌نامه', {
      default: 24,
      rules: [
        eqRule('rule_has_policy', 20, 19, 18, 'has_previous_policy', '1'),
        eqRule('rule_no_policy', 24, 19, 18, 'has_previous_policy', '2')
      ]
    }),
    radio(19, 'بیمه‌نامه از قبل دارید؟', 'has_previous_policy', [
      {label: 'بله'},
      {label: 'خیر'}
    ]),

    step(20, 'اطلاعات بیمه‌نامه قبلی', {default: 24, rules: []}),
    text(21, 'شماره بیمه‌نامه', 'policy_number'),
    text(22, 'شرکت بیمه', 'insurer'),
    text(23, 'تاریخ پایان بیمه‌نامه', 'policy_end'),

    step(24, 'محاسبه حق بیمه', {default: '', rules: []})
  ]
}
